import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import { AccountType } from '@jotta/grpc-connect-openapi/customer'
import { navigate } from '@jotta/router'
import { AppLayoutPortal } from '@jotta/ui/AppLayoutPortal'
import { ErrorPage } from '@jotta/ui/ErrorPage'

import { BizBoundary } from '../components/BizBoundary'
import { BizUserLimitAlert } from '../components/BizUserLimitAlert'

import { BizHeader } from './BizHeader'

export function BizLayout() {
  const query = useGetCustomer()
  const customer = query.data
  const company = customer?.business
  const businessAdmin =
    company && customer && customer.accountType === AccountType.BUSINESS_ADMIN
  // Redirect to files if customer has fetched and is not a business admin
  const shouldRedirect = customer && !businessAdmin
  useEffect(() => {
    if (shouldRedirect) {
      navigate('/web/sync')
    }
  }, [shouldRedirect])

  if (businessAdmin) {
    return (
      <>
        <AppLayoutPortal slot="moduleNav">
          <BizHeader />
        </AppLayoutPortal>
        <div className="px-6 py-4">
          <div className="relative flex flex-col gap-3 pb-16 lg:pb-4">
            <BizBoundary>
              <BizUserLimitAlert />
              <Outlet />
            </BizBoundary>
          </div>
        </div>
      </>
    )
  }
  if (query.isLoading) {
    return <div className="loading"></div>
  }
  if (query.isError) {
    return <ErrorPage error={query.error} />
  }
}
